import { css } from "@emotion/css"

import VisuallyHidden from "@p-ban/common/src/components/layout/VisuallyHidden"
import useFocusVisible from "@p-ban/common/src/hooks/useFocusVisible"

type Props = {
  type: "checkbox" | "radio"
  renderIcon: (isFocusVisible: boolean) => React.ReactElement

  name?: string
  value?: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  checked: boolean
  disabled?: boolean

  children: React.ReactNode
  direction?: "row" | "row-reverse"
}

const RadioAndCheckBoxBase = ({ renderIcon, children, direction = "row", ...props }: Props) => {
  const { isFocusVisible, focusVisibleProps } = useFocusVisible()

  return (
    <label>
      <VisuallyHidden>
        <input {...focusVisibleProps} {...props} />
      </VisuallyHidden>
      <span className={styles.container} style={{ flexDirection: direction }}>
        {renderIcon(isFocusVisible)}
        <span>{children}</span>
      </span>
    </label>
  )
}
export default RadioAndCheckBoxBase

const styles = {
  container: css`
    display: flex;
    column-gap: 8px;
    align-items: center;
    > span {
      height: 13px;
    }
  `,
}
